export enum PermissionCategory {
  DASHBOARD = 'dashboard',
  CUSTOMERS = 'customers',
  MARKETING = 'marketing',
  LOCATIONS = 'locations',
  EVENTS = 'events',
  PRODUCTS = 'products',
  BRANDS = 'brands',
  LIBRARY = 'library',
  FANDA = 'fanda',
  USERS = 'users',
  SETTINGS = 'settings',
  OFFERS = 'offers',
  BRAND_LINKING = 'brand-linking',
  ONBOARDING = 'onboarding',
  ORGANIZATIONS = 'organizations',
  NOTIFICATIONS = 'notifications',
}

export enum PermissionAction {
  VIEW = 'view',
  CREATE = 'create',
  EDIT = 'edit',
  DELETE = 'delete',
  INVITE = 'invite',
  UPDATE = 'update',
}

export enum Permission {
  // Dashboard
  DASHBOARD_VIEW_NAV_BAR = 'dashboard:view:nav-bar-item',
  DASHBOARD_VIEW_GENERAL_OVERVIEW = 'dashboard:view:general-overview',
  DASHBOARD_VIEW_EXPORT_PDF = 'dashboard:view:export-pdf',
  DASHBOARD_VIEW_POINTS_LIABILITY = 'dashboard:view:points-liability-insights',

  // Customers
  CUSTOMERS_VIEW_NAV_BAR = 'customers:view:nav-bar-item',
  CUSTOMERS_VIEW_GRID = 'customers:view:grid',
  CUSTOMERS_VIEW_DETAILS = 'customers:view:details',
  CUSTOMERS_VIEW_AUDIENCES_TAB = 'customers:view:audiences-tab',
  CUSTOMERS_VIEW_SEGMENTS = 'customers:view:segments',
  CUSTOMERS_VIEW_REPORTING = 'customers:view:reporting',
  CUSTOMERS_VIEW_WALLET = 'customers:view:wallet',
  CUSTOMERS_VIEW_EVENTS = 'customers:view:events-own',
  CUSTOMERS_VIEW_LOCATIONS = 'customers:view:locations-own',
  CUSTOMERS_CREATE_NEW = 'customers:create:new',
  CUSTOMERS_EDIT_DETAILS = 'customers:edit:details',
  CUSTOMERS_EDIT_ADJUST_POINTS = 'customers:edit:adjust-points',
  CUSTOMERS_EDIT_GIVE_REWARD = 'customers:edit:give-reward',
  CUSTOMERS_EDIT_BUY_REWARD = 'customers:edit:buy-reward',

  // Marketing
  MARKETING_VIEW_NAV_BAR = 'marketing:view:nav-bar-item',
  MARKETING_VIEW_CAMPAIGNS = 'marketing:view:campaigns',
  MARKETING_VIEW_REPORTING = 'marketing:view:reporting',
  MARKETING_VIEW_AUDIENCES = 'marketing:view:audiences',
  MARKETING_CREATE_CAMPAIGN = 'marketing:create:campaign',
  MARKETING_EDIT_CAMPAIGNS = 'marketing:edit:campaigns',
  MARKETING_DELETE_CAMPAIGNS = 'marketing:delete:campaigns',

  // Locations
  LOCATIONS_VIEW_NAV_BAR = 'locations:view:nav-bar-item',
  LOCATIONS_VIEW_MY_LOCATIONS = 'locations:view:locations-own',
  LOCATIONS_VIEW_GRID = 'locations:view:grid',
  LOCATIONS_VIEW_LOCATION_OFFERS = 'locations:view:location-offers',
  LOCATIONS_VIEW_BRAND_LOCATIONS = 'locations:view:brand-locations',
  LOCATIONS_VIEW_REPORTING = 'locations:view:reporting',
  LOCATIONS_CREATE_UI = 'locations:create:ui',
  LOCATIONS_CREATE_IMPORT = 'locations:create:import',
  LOCATIONS_EDIT_DETAILS = 'locations:edit:details',
  LOCATIONS_EDIT_ACTIVATION = 'locations:edit:activation',
  LOCATIONS_EDIT_CONNECT = 'locations:edit:connect',
  LOCATIONS_EDIT_DELETE_CONNECTION = 'locations:edit:delete-connection',
  LOCATIONS_DELETE_ARCHIVE = 'locations:delete:archive',

  // Events/Logs
  EVENTS_VIEW_NAV_BAR = 'events:view:nav-bar-item',
  EVENTS_VIEW_GRID_GENERAL = 'events:view:grid-general',
  EVENTS_VIEW_GRID_ADMIN = 'events:view:grid-admin',
  EVENTS_VIEW_REPORTING = 'events:view:reporting',

  // Campaigns
  CAMPAIGNS_VIEW_NAV_BAR = 'campaigns:view:nav-bar-item',
  CAMPAIGNS_VIEW_GRID = 'campaigns:view:grid',
  CAMPAIGNS_VIEW_GRID_ADMIN = 'campaigns:view:grid-admin',
  CAMPAIGNS_VIEW_CAMPAIGN = 'campaigns:view:campaign',
  CAMPAIGNS_VIEW_CAMPAIGN_ADMIN = 'campaigns:view:campaign-admin',
  CAMPAIGNS_CREATE = 'campaigns:create:campaign',
  CAMPAIGNS_CREATE_ADMIN = 'campaigns:create:campaign-admin',
  PROMOS_EDIT_LANDING_PAGE = 'promos:edit:landing-page',

  // Products
  PRODUCTS_VIEW_NAV_BAR = 'products:view:nav-bar-item',
  PRODUCTS_VIEW_MY_BRAND = 'products:view:brand-own',
  PRODUCTS_VIEW_REPORTING = 'products:view:reporting',
  PRODUCTS_CREATE_PRODUCT = 'products:create:product',
  PRODUCTS_CREATE_CATEGORY = 'products:create:category',
  PRODUCTS_CREATE_IMPORT = 'products:create:import',
  PRODUCTS_EDIT_DETAILS = 'products:edit:details',
  PRODUCTS_DELETE_PRODUCT = 'products:delete:product',

  // Brands
  BRANDS_VIEW_NAV_BAR = 'brands:view:nav-bar-item',
  BRANDS_VIEW_MY_BRAND = 'brands:view:brand-own',
  BRANDS_VIEW_GRID_ORGANIZATION = 'brands:view:grid-organization',
  BRANDS_VIEW_REPORTING = 'brands:view:reporting',
  BRANDS_CREATE_BRAND = 'brands:create:brand',
  BRANDS_CREATE_CUSTOM_BRAND = 'brands:create:custom-brand',
  BRANDS_EDIT_CONNECT = 'brands:edit:connect',
  BRANDS_EDIT_DISCONNECT = 'brands:edit:disconnect',
  BRANDS_EDIT_CONNECT_LOCATION = 'brands:edit:connect-location',
  BRANDS_EDIT_DISCONNECT_LOCATION = 'brands:edit:disconnect-location',
  BRANDS_EDIT_APPROVE_REJECT = 'brands:edit:approve-reject',
  BRANDS_EDIT_ACTIVATION = 'brands:edit:activation',
  BRANDS_EDIT_ACTIVATION_ADMIN = 'brands:edit:activation-admin',
  BRANDS_DELETE_BRAND = 'brands:delete:brand',

  // Library
  LIBRARY_VIEW_NAV_BAR = 'library:view:nav-bar-item',
  LIBRARY_VIEW_GRID = 'library:view:grid',
  LIBRARY_VIEW_ITEM = 'library:view:item',
  LIBRARY_CREATE_ITEM = 'library:create:item',
  LIBRARY_EDIT_ITEM = 'library:edit:item',

  // Fanda
  FANDA_VIEW_BUTTON = 'fanda:view:button',
  FANDA_VIEW_BULK_ACCOUNT = 'fanda:view:bulk-account',
  FANDA_VIEW_CFS_SLIDER = 'fanda:view:cfs-slider',
  FANDA_VIEW_POS_RULES = 'fanda:view:pos-rules',

  // Users (Manage users and profile)
  USERS_VIEW_NAV_BAR = 'users:view:nav-bar-item',
  USERS_VIEW_GRID = 'users:view:grid',
  USERS_VIEW_PROFILE = 'users:view:profile',
  USERS_EDIT_PROFILE = 'users:edit:profile',
  USERS_EDIT_ROLE = 'users:edit:role',
  USERS_EDIT_ACTIVITY = 'users:edit:activity',
  USERS_DELETE_USER = 'users:delete:user',

  // Settings
  SETTINGS_VIEW_NAV_BAR = 'settings:view:nav-bar-item',
  SETTINGS_CREATE = 'settings:create',
  SETTINGS_EDIT_POINTS = 'settings:edit:points',
  SETTINGS_EDIT_ACCOUNT = 'settings:edit:account',
  SETTINGS_EDIT_BILLING = 'settings:edit:billing',
  SETTINGS_DELETE = 'settings:delete',

  // Offers
  OFFERS_VIEW_NAV_BAR = 'offers:view:nav-bar-item',
  OFFERS_VIEW_GRID_OWN = 'offers:view:grid-own',
  OFFERS_VIEW_GRID_ORGANIZATION = 'offers:view:grid-organization',
  OFFERS_VIEW_GRID_AMBASSADOR = 'offers:view:grid-ambassador',
  OFFERS_VIEW_GRID_ADMIN = 'offers:view:grid-admin',
  OFFERS_VIEW_REPORTING = 'offers:view:reporting',
  OFFERS_CREATE_OFFER = 'offers:create:offer',
  OFFERS_CREATE_OFFER_ADMIN = 'offers:create:offer-admin',
  OFFERS_CREATE_ASSOCIATE_PRODUCT = 'offers:create:associate-product',
  OFFERS_CREATE_ASSOCIATE_BRAND = 'offers:create:associate-brand',
  OFFERS_CREATE_ASSOCIATE_AUDIENCE = 'offers:create:associate-audience',
  OFFERS_CREATE_ASSOCIATE_TIER = 'offers:create:associate-tier',
  OFFERS_CREATE_SET_CATEGORY = 'offers:create:set-category',
  OFFERS_CREATE_SET_PRIORITY = 'offers:create:set-priority',
  OFFERS_CREATE_VOUCHER = 'offers:create:voucher',
  OFFERS_CREATE_VOUCHER_PRODUCT = 'offers:create:voucher-product',
  OFFERS_CREATE_VOUCHER_BRAND = 'offers:create:voucher-brand',
  OFFERS_CREATE_VOUCHER_AUDIENCE = 'offers:create:voucher-audience',
  OFFERS_CREATE_VOUCHER_TIER = 'offers:create:voucher-tier',
  OFFERS_CREATE_VOUCHER_CATEGORY = 'offers:create:voucher-category',
  OFFERS_CREATE_VOUCHER_PRIORITY = 'offers:create:voucher-priority',
  OFFERS_CREATE_VOUCHER_CODE = 'offers:create:voucher-code',
  OFFERS_CREATE_VOUCHER_URL = 'offers:create:voucher-url',
  OFFERS_CREATE_PAY_WITH_POINTS = 'offers:create:pay-with-points',
  OFFERS_CREATE_SUBMIT = 'offers:create:submit',
  OFFERS_CREATE_CLONE = 'offers:create:clone',
  OFFERS_EDIT_APPROVE = 'offers:edit:approve',
  OFFERS_EDIT_APPROVE_WITH_MODIFICATION = 'offers:edit:approve-with-modification',
  OFFERS_EDIT_REJECT = 'offers:edit:reject',
  OFFERS_EDIT_EDIT_DRAFT = 'offers:edit:edit-draft',
  OFFERS_EDIT_ARCHIVE = 'offers:edit:archive',
  OFFERS_DELETE_DRAFT = 'offers:delete:draft',
  OFFERS_DELETE_RECALL = 'offers:delete:recall',

  // Brand linking
  BRAND_LINKING_VIEW_NAV_BAR = 'brand-linking:view:nav-bar-item',
  BRAND_LINKING_CREATE_LINK_ORGANIZATION = 'brand-linking:create:link-organization',
  BRAND_LINKING_CREATE_LINK_BRAND = 'brand-linking:create:link-brand',
  BRAND_LINKING_EDIT_UNLINK = 'brand-linking:edit:unlink',
  BRAND_LINKING_EDIT_DETAILS = 'brand-linking:edit:details',
  BRAND_LINKING_DELETE_CONNECTION = 'brand-linking:delete:connection',

  // Onboarding
  ONBOARDING_VIEW_PAGE = 'onboarding:view:page',
  ONBOARDING_CREATE_COMPLETE = 'onboarding:create:complete',

  // Organizations
  ORGANIZATIONS_VIEW_NAV_BAR = 'organizations:view:nav-bar-item',
  ORGANIZATIONS_VIEW_GRID = 'organizations:view:grid',
  ORGANIZATIONS_VIEW_DETAILS = 'organizations:view:details',
  ORGANIZATIONS_VIEW_DETAILS_ADMIN = 'organizations:view:details-admin',
  ORGANIZATIONS_VIEW_GRID_MEMBERS = 'organizations:view:grid-members',
  ORGANIZATIONS_VIEW_GRID_MEMBERS_ADMIN = 'organizations:view:grid-members-admin',
  ORGANIZATIONS_VIEW_MEMBERS_ALL = 'organizations:view:members-all',
  ORGANIZATIONS_VIEW_MEMBER_PROFILE = 'organizations:view:member-profile',
  ORGANIZATIONS_VIEW_MEMBER_PROFILE_ADMIN = 'organizations:view:member-profile-admin',
  ORGANIZATIONS_EDIT_DETAILS = 'organizations:edit:details',
  ORGANIZATIONS_EDIT_DETAILS_ADMIN = 'organizations:edit:details-admin',
  ORGANIZATIONS_EDIT_APPROVAL_STATUS = 'organizations:edit:approval-status',
  ORGANIZATIONS_EDIT_ACTIVITY_STATUS = 'organizations:edit:activity-status',
  ORGANIZATIONS_EDIT_MEMBER_PROFILE_ADMIN = 'organizations:edit:member-profile-admin',
  ORGANIZATIONS_EDIT_MEMBER_ROLE_ADMIN = 'organizations:edit:member-role-admin',
  ORGANIZATIONS_EDIT_MEMBER_PROFILE = 'organizations:edit:member-profile',
  ORGANIZATIONS_EDIT_MEMBER_ROLE = 'organizations:edit:member-role',
  ORGANIZATIONS_EDIT_MEMBER_ACTIVITY_ADMIN = 'organizations:edit:member-activity-admin',
  ORGANIZATIONS_EDIT_MEMBER_ACTIVITY = 'organizations:edit:member-activity',
  ORGANIZATIONS_DELETE_MEMBER = 'organizations:delete:member',
  ORGANIZATIONS_DELETE_MEMBER_ADMIN = 'organizations:delete:member-admin',
  ORGANIZATIONS_INVITE_MEMBER = 'organizations:invite:member',

  // Notifications
  NOTIFICATIONS_VIEW_OWN = 'notifications:view:own',
  NOTIFICATIONS_UPDATE_OWN = 'notifications:update:own',
}
